/**
 * 复选框相关
 */
export default {
    data () {
        return {
            lptypesCheckAll: true, // 理赔方式全选
            brandCheckAll: true, // 品牌全选
            sizeCheckAll: true, // 尺寸全选
            customerIds: [], // 客户id集合
            productIds: [], // 货品id集合
            // 暂不可用，待配置
            customerConfig_: [{
                    prop: 'customer',
                    label: '客户编码',
                    width: 170,
                    json: {
                        size: 'small',
                        api: 'manage/customer',
                        prop: 'account_display'
                    },
                    component: 'LyAutoProduct'
                }, {
                    prop: 'customer',
                    label: '客户名称',
                    width: 170,
                    json: {
                        size: 'small',
                        api: 'manage/customer',
                        prop: 'customer_name'
                    },
                    component: 'LyAutoProduct'
                }, {
                    prop: 'customer',
                    label: '联系人',
                    width: 170,
                    json: {
                        size: 'small',
                        api: 'manage/customer',
                        prop: 'name_contract'
                    },
                    component: 'LyAutoProduct'
                }, {
                    prop: 'customer',
                    label: '联系电话',
                    width: 170,
                    json: {
                        size: 'small',
                        api: 'manage/customer',
                        prop: 'tel'
                    },
                    component: 'LyAutoProduct'
            }],
            // 暂时借用product的数据
            customerConfig: [{
                    prop: 'customer',
                    label: '客户编码',
                    width: 150,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_account',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
                }, {
                    prop: 'customer',
                    label: '客户名称',
                    width: 300,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_name',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
                }, {
                    prop: 'customer',
                    label: '联系人',
                    width: 150,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_contact',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
                }, {
                    prop: 'customer',
                    label: '联系手机',
                    width: 160,
                    json: {
                        size: 'small',
                        api: 'api/customer',
                        prop: 'customer_tel',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account'
                        }, {
                            label: '客户名称',
                            prop: 'customer_name'
                        }, {
                            label: '联系人',
                            prop: 'customer_contact'
                        }, {
                            label: '联系电话',
                            prop: 'customer_tel'
                        }]
                    },
                    component: 'LyAutoSearch'
            }],
            productConfig: [{
                    prop: 'product',
                    label: '货品编码',
                    width: 150,
                    json: {
                        size: 'small',
                        api: 'manage/product',
                        prop: 'product_cai'
                    },
                    component: 'LyAutoProduct'
                }, {
                    prop: 'product',
                    label: '货品名称',
                    width: 370,
                    json: {
                        size: 'small',
                        prop: 'product_name'
                    },
                    component: 'LyAutoProduct'
            }]
        }
    },
    mounted () {                    
        // 初始化理赔方式全选
        this.sblpmx.lp_type = this.lptypes.map((item) => {
            return item.id;
        }); 
        // 初始化尺寸全选
        this.sblpzh.size = this.sizes.map((item) => {
            return item.id;
        });     
    }
}